export const RESULTS = '/results';
export const RESULTS_INSURANCE_DETAILS = '/insurance-details';
export const PENSION_MOVE_CONFIRMATION = '/confirmation';
export const PENSION_MOVE_TRANSFER = '/transfer';
export const PENSION_MOVE_SUMMARY = '/summary';
export const REQUEST_ADVISORY_MEETING = '/request-advisory-meeting';
